import * as React from "react";
import Dialog from "@mui/material/Dialog";

import ChangePassword from "./ChangePassword";
import DeleteModal from "./modal/logoutModal";
import Add_Party_modal from "../../pages/Dealer-wise/Add_party_modal";
import AddSurface_modal from "../../pages/Settings/Surface/AddSurface_modal";
import AddSize_modal from "../../pages/Settings/Size/AddSize_modal";
import ViewProduct from "../../pages/Settings/Product/ViewProduct";
import AddCategory from "../../pages/Settings/Category/AddCategory";
import AddWarehouse from "../../pages/Settings/Warehouse/AddWarehouse";
import AddStock from "../../pages/Inventory/Stock/AddStock";
import Add_textConfig_modal from "../../pages/Settings/Text Config/Add_textConfig_modal";
import ViewUserModel from "../../pages/Settings/User Management/View_User";
import { Update } from "@mui/icons-material";
import UpdateStatus from "./modal/UpdateStatus";
import Delete_Modal from "./modal/Delete_Modal";
import Delete from "./modal/Delete";
import AddUom_modal from "../../pages/Settings/Uom/AddUom_modal";
import Conformation from "./modal/Conformation";
import AddReason_modal from "../../pages/Settings/Reason/AddReason_modal";
import History_modal from "../../pages/Sample Request/History_modal";
import Upload_Product_modal from "../../pages/Settings/Product/Upload_Product_modal";
import UploadStock from "../../pages/Inventory/Stock/UploadStock";


export default function CommonModal({
  handleClose,
  modalOpen,
  setShow,
  show,
  handelClick,
  stockFile,
  setStockFile,
}) {
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="Common_modal"
      open={modalOpen.open}
      className={modalOpen.class}
    >
      {modalOpen.currentComponent === "changePassword" && (
        <ChangePassword
          handleClose={handleClose}
          modalOpen={modalOpen}
          setShow={setShow}
          show={show}
        />
      )}
      {modalOpen.currentComponent === "logout" && (
        <DeleteModal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "updatestatus" && (
        <UpdateStatus
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "Add Dealer" && (
        <Add_Party_modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "AddSurface" && (
        <AddSurface_modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "AddCategory" && (
        <AddCategory
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "AddWarehouse" && (
        <AddWarehouse
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "AddStock" && (
        <AddStock
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "Addtextconfig" && (
        <Add_textConfig_modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "AddSize" && (
        <AddSize_modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "AddUom" && (
        <AddUom_modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}

      {modalOpen.currentComponent === "viewuser" && (
        <ViewUserModel
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {modalOpen.currentComponent === "deletemodal" && (
        <Delete_Modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}

        />
      )}
      {modalOpen.currentComponent === "reasonmodal" && (
        <AddReason_modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}

        />
      )}
      {modalOpen.currentComponent === "history_Modal" && (
        <History_modal
          handleClose={handleClose}
          handelClick={handelClick}
          modalOpen={modalOpen}
        />
      )}
      {
        modalOpen.currentComponent === "upload_product" && (
          <Upload_Product_modal
            handleClose={handleClose}
            handelClick={handelClick}
            modalOpen={modalOpen}
          />
        )}

      {
        modalOpen.currentComponent === "uploadStock" && (
          <UploadStock
            handleClose={handleClose}
            handelClick={handelClick}
            modalOpen={modalOpen}
            stockFile={stockFile}
            setStockFile={setStockFile}
          />
        )}
      {['conform'].includes(modalOpen.currentComponent) && (
        <Conformation handleClose={handleClose} modalOpen={modalOpen} handelClick={handelClick} />
      )}
      {['delete', 'status', 'changepassword'].includes(modalOpen.currentComponent) && (
        <Delete handleClose={handleClose} modalOpen={modalOpen} handelClick={handelClick} />
      )}
    </Dialog>
  );
}
